export default __webpack_public_path__ + "static/media/sponsor-icon.1373b798.svg";